module.exports = __webpack_public_path__ + "img/notes.e08ff3d3.svg";